import { Heading } from './Heading';
import { Text } from './Text';

export const Typography = {
  Heading: Heading,
  Text: Text,
};

export type { HeadingProps, TextProps } from './types';
